 export enum TraitementEnCoursEnum {
Ouverture = 0,
SoumettreSaisie = 1,
ValiderSaisie = 2,
Cloture = 3,
Aucun = 4,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TraitementEnCoursEnum.ts